import { Action, Module, VuexModule } from "vuex-module-decorators";
import { CiviLifeNewsType } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ServiceModule extends VuexModule {
    @Action
    [CiviLifeNewsType.listCiviLifeNewsType]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/civi-life-news-type/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [CiviLifeNewsType.findPageCiviLifeNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/civi-life-news-type`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [CiviLifeNewsType.saveCiviLifeNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/civi-life-news-type/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [CiviLifeNewsType.deleteCiviLifeNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/civi-life-news-type/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}